module.exports = __webpack_public_path__ + "static/img/li8_2.739204ec.png";